<template>
  <div>
    <v-layout row wrap>
      <v-flex sm2 xs3 class="pt-2 pb-2">
        {{attendance.expectedAttendanceDatetime | date}}
      </v-flex>
      <v-flex md6 sm5 xs6 class="pt-2 pr-1">
        {{attendance.description}}
      </v-flex>
      <v-flex sm3 hidden-xs-only class="pt-2 pr-1">
        {{attendance.attendanceStatus}}
      </v-flex>
      <v-flex xs3 sm2 md1 class="pt-2 pr-1">
        <v-icon v-if="attendance.mandatory">mdi-calendar-check</v-icon>
        <v-icon v-else>mdi-blank</v-icon>
        <v-icon v-if="attendance.attended">mdi-check</v-icon>
        <v-icon v-if="!attendance.attended">mdi-window-close</v-icon>
      </v-flex>
    </v-layout>
    <v-divider></v-divider>
  </div>
</template>

<script>
  import DateFormat from '../../mixins/DateFormat'

  export default {
    name: 'student-attendance-row',
    props: ['attendance'],
    mixins: [DateFormat]
  }
</script>



// WEBPACK FOOTER //
// src/components/student/StudentAttendanceRow.vue